<form [formGroup]="inputForm" id="afmInputs" (ngSubmit)="onSubmit()" class="input-form">
    <h3>{{ formTitle }}</h3>
    <span class="font-italic hint">Πατήστε στο</span>
    <span><img class="px-1 plus-icon" src="/assets/images/plus.png" alt="add" /></span>
    <span class="font-italic hint">{{ formSubtitle }}</span>
    <div class="input-group mt-3" formArrayName="afmInputs">
        <div *ngFor="let inputCtrl of formArray.controls; let i = index" [formGroupName]="i" class="col-12 afm-group">
            <div class="d-flex align-items-center w-100 pb-3">
                <input
                    class="form-control width-custom"
                    type="text"
                    [name]="'name' + i"
                    [id]="'input' + i"
                    formControlName="afmInput"
                    placeholder="ΑΦΜ"
                    [readonly]="isCompany(i) || isUnderage(i)"
                />
                <img *ngIf="i > 0 && !inputDisabled(i)" (click)="onDeleteAfmInput(i)" class="pl-2 icon-large" src="/assets/images/minus2x.png" alt="remove" />
                <img *ngIf="formArray.controls.length - 1 === i" (click)="onAddAfmInput()" class="pl-2 icon-large" src="/assets/images/plus2x.png" alt="add" />
            </div>

            <div class="d-flex" *ngIf="isCompany(i)">
                <input
                    class="form-control width-custom mb-2 mr-2 col-md-6"
                    type="text"
                    [name]="'representativeAfm' + i"
                    [id]="'representativeAfm' + i"
                    formControlName="representativeAfm"
                    placeholder="ΑΦΜ αντιπροσώπου"
                />
                <input
                    class="form-control width-custom mb-2 col-md-6"
                    type="text"
                    [name]="'representativeEmail' + i"
                    [id]="'representativeEmail' + i"
                    formControlName="representativeEmail"
                    placeholder="E-mail αντιπροσώπου"
                />
            </div>
            <div class="d-flex" *ngIf="isUnderage(i)">
                <input
                    class="form-control width-custom mb-2 mr-2 col-md-6"
                    type="text"
                    [name]="'representativeAfm-' + i"
                    [id]="'representativeAfm-' + i"
                    formControlName="representativeAfm"
                    placeholder="ΑΦΜ αντιπροσώπου 1"
                />
                <input
                    class="form-control width-custom mb-2 mr-2 col-md-6"
                    type="text"
                    [name]="'representativeAfm2-' + i"
                    [id]="'representativeAfm2-' + i"
                    formControlName="representativeAfm2"
                    placeholder="ΑΦΜ αντιπροσώπου 2"
                />
            </div>
        </div>
    </div>
    <app-button
        [label]="submitButtonConfig.label"
        [hint]="submitButtonConfig.hint"
        [actionCallback]="submitButtonConfig.actionCallback"
        [classes]="submitButtonConfig.classes"
        [disabled]="inputForm.invalid || inputForm.status === 'DISABLED'"
    ></app-button>
</form>
